"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHIFT_DIFF_PARSER = void 0;
const moment_1 = __importStar(require("moment"));
const react_1 = __importDefault(require("react"));
const _1 = require(".");
const format_hours_1 = require("./format-hours");
const isValidDate = (value) => (0, _1.isValue)(value) && typeof value === 'string' && (0, moment_1.default)(value, [moment_1.ISO_8601]).isValid();
const isValidNumber = (value) => (0, _1.isValue)(value) && typeof value === 'number' && !Number.isNaN(value);
const isValidString = (value) => (0, _1.isValue)(value) && typeof value === 'string';
const NULL_VALUE = '[-]';
const SHIFT_DIFF_PARSER = ({ employees, 
// contracts,
contractTypes, positions, }) => Object.freeze({
    period: {
        start: (_, oldValue, newValue) => (react_1.default.createElement("span", null,
            react_1.default.createElement("b", null, (0, _1.t)('SHIFT_START')),
            ' ',
            isValidDate(oldValue)
                ? (0, moment_1.default)(oldValue).format('DD.MM.YY HH:mm')
                : NULL_VALUE,
            ' ',
            "->",
            ' ',
            isValidDate(newValue)
                ? (0, moment_1.default)(newValue).format('DD.MM.YY HH:mm')
                : NULL_VALUE)),
        end: (_, oldValue, newValue) => (react_1.default.createElement("span", null,
            react_1.default.createElement("b", null, (0, _1.t)('SHIFT_END')),
            ' ',
            isValidDate(oldValue)
                ? (0, moment_1.default)(oldValue).format('DD.MM.YY HH:mm')
                : NULL_VALUE,
            ' ',
            "->",
            ' ',
            isValidDate(newValue)
                ? (0, moment_1.default)(newValue).format('DD.MM.YY HH:mm')
                : NULL_VALUE)),
    },
    // pauses: {
    //   start: (_, oldValue, newValue) => (
    //     <span>
    //       <b>{t('PAUSE_START')}: </b>
    //     </span>
    //   ),
    //   end: (_, oldValue, newValue) => (
    //     <span>
    //       <b>{t('PAUSE_END')}</b>
    //     </span>
    //   ),
    // },
    stats: {
        totalMinutes: (_, oldValue, newValue) => (react_1.default.createElement("span", null,
            react_1.default.createElement("b", null,
                (0, _1.t)('SHIFT_STATS_TITLE'),
                " - ",
                (0, _1.t)('ATTENDANCE_HOURS_LABEL.atWork'),
                ":"),
            ' ',
            isValidNumber(oldValue) ? (0, format_hours_1.formatHours)(oldValue / 60) : NULL_VALUE,
            " ->",
            ' ',
            isValidNumber(newValue) ? (0, format_hours_1.formatHours)(newValue / 60) : NULL_VALUE)),
        workMinutes: (_, oldValue, newValue) => (react_1.default.createElement("span", null,
            react_1.default.createElement("b", null,
                (0, _1.t)('SHIFT_STATS_TITLE'),
                " - ",
                (0, _1.t)('WORK_TIME'),
                ":"),
            ' ',
            isValidNumber(oldValue) ? (0, format_hours_1.formatHours)(oldValue / 60) : NULL_VALUE,
            " ->",
            ' ',
            isValidNumber(newValue) ? (0, format_hours_1.formatHours)(newValue / 60) : NULL_VALUE)),
        workDayMinutes: (_, oldValue, newValue) => (react_1.default.createElement("span", null,
            react_1.default.createElement("b", null,
                (0, _1.t)('SHIFT_STATS_TITLE'),
                " - ",
                (0, _1.t)('REPORTS_EMP_VAL_WORKDAYTIME'),
                ":"),
            ' ',
            isValidNumber(oldValue) ? (0, format_hours_1.formatHours)(oldValue / 60) : NULL_VALUE,
            " ->",
            ' ',
            isValidNumber(newValue) ? (0, format_hours_1.formatHours)(newValue / 60) : NULL_VALUE)),
        weekEndMinutes: (_, oldValue, newValue) => (react_1.default.createElement("span", null,
            react_1.default.createElement("b", null,
                (0, _1.t)('SHIFT_STATS_TITLE'),
                " - ",
                (0, _1.t)('CYC_PRE_WEEKENDS'),
                ":"),
            ' ',
            isValidNumber(oldValue) ? (0, format_hours_1.formatHours)(oldValue / 60) : NULL_VALUE,
            " ->",
            ' ',
            isValidNumber(newValue) ? (0, format_hours_1.formatHours)(newValue / 60) : NULL_VALUE)),
        saturdayMinutes: (_, oldValue, newValue) => (react_1.default.createElement("span", null,
            react_1.default.createElement("b", null,
                (0, _1.t)('SHIFT_STATS_TITLE'),
                " - ",
                (0, _1.t)('ATTENDANCE_HOURS_LABEL.saturdays'),
                ":"),
            ' ',
            isValidNumber(oldValue) ? (0, format_hours_1.formatHours)(oldValue / 60) : NULL_VALUE,
            " ->",
            ' ',
            isValidNumber(newValue) ? (0, format_hours_1.formatHours)(newValue / 60) : NULL_VALUE)),
        sundayMinutes: (_, oldValue, newValue) => (react_1.default.createElement("span", null,
            react_1.default.createElement("b", null,
                (0, _1.t)('SHIFT_STATS_TITLE'),
                " - ",
                (0, _1.t)('ATTENDANCE_HOURS_LABEL.sundays'),
                ":"),
            ' ',
            isValidNumber(oldValue) ? (0, format_hours_1.formatHours)(oldValue / 60) : NULL_VALUE,
            " ->",
            ' ',
            isValidNumber(newValue) ? (0, format_hours_1.formatHours)(newValue / 60) : NULL_VALUE)),
    },
    note: (_, __, newValue) => typeof newValue === 'string' ? (react_1.default.createElement("span", null,
        react_1.default.createElement("b", null, (0, _1.t)('NOTE')),
        ": ",
        newValue)) : (NULL_VALUE),
    userId: (_, oldValue, newValue) => (react_1.default.createElement("span", null,
        react_1.default.createElement("b", null, (0, _1.t)('USER')),
        ":",
        ' ',
        isValidString(oldValue)
            ? (employees?.find((emp) => emp.id === oldValue)?.name ?? '[?]')
            : NULL_VALUE,
        ' ',
        "->",
        ' ',
        isValidString(newValue)
            ? (employees?.find((emp) => emp.id === newValue)?.name ?? '[?]')
            : NULL_VALUE)),
    positionId: (_, oldValue, newValue) => (react_1.default.createElement("span", null,
        react_1.default.createElement("b", null, (0, _1.t)('POSITION')),
        ":",
        ' ',
        isValidString(oldValue)
            ? (positions?.find((pos) => pos.id === oldValue)?.name ?? '[?]')
            : NULL_VALUE,
        ' ',
        "->",
        ' ',
        isValidString(newValue)
            ? (positions?.find((emp) => emp.id === newValue)?.name ?? '[?]')
            : NULL_VALUE)),
    contractType: (_, oldValue, newValue) => (react_1.default.createElement("span", null,
        react_1.default.createElement("b", null, (0, _1.t)('CONTRACT_TYPES')),
        ":",
        isValidString(oldValue)
            ? (contractTypes?.find((pos) => pos.id === oldValue)?.name ?? '[?]')
            : NULL_VALUE,
        ' ',
        "->",
        ' ',
        isValidString(newValue)
            ? (contractTypes?.find((emp) => emp.id === newValue)?.name ?? '[?]')
            : NULL_VALUE)),
});
exports.SHIFT_DIFF_PARSER = SHIFT_DIFF_PARSER;
